/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clock: NonNullable<unknown> }} Workout_Live_Paused_ClockInputs */

const en_us2_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout time ${i?.clock}, paused`)
};

const pt_br2_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo de treino ${i?.clock}, pausado`)
};

const es_419_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiempo de entrenamiento ${i?.clock}, en pausa`)
};

const pt_pt2_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo de treino ${i?.clock}, em pausa`)
};

const fr_fr2_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Durée de séance ${i?.clock}, en pause`)
};

const de_de2_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trainingszeit ${i?.clock}, pausiert`)
};

const it_it2_workout_live_paused_clock = /** @type {(inputs: Workout_Live_Paused_ClockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tempo di allenamento ${i?.clock}, in pausa`)
};

/**
* | output |
* | --- |
* | "Workout time {clock}, paused" |
*
* @param {Workout_Live_Paused_ClockInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_paused_clock = /** @type {((inputs: Workout_Live_Paused_ClockInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Paused_ClockInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_paused_clock(inputs)
	if (locale === "es-419") return es_419_workout_live_paused_clock(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_paused_clock(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_paused_clock(inputs)
	if (locale === "de-DE") return de_de2_workout_live_paused_clock(inputs)
	if (locale === "it-IT") return it_it2_workout_live_paused_clock(inputs)
	return en_us2_workout_live_paused_clock(inputs)
});
export { workout_live_paused_clock as "workout-live.paused_clock" }